<div class="page-wrapper">
    <div class="page-header">
        <div>
            <h1>Redeem Requests</h1>
            <p>Review and manage customer point redemptions</p>
        </div>
    </div>

    <!-- Summary Cards -->

    <div class="summary-grid">

        <div class="summary-card pending">
            <mat-icon>schedule</mat-icon>
            <div>
                <h2>{{ pendingCount }}</h2>
                <span>Pending</span>
            </div>
        </div>

        <div class="summary-card approved">
            <mat-icon>check_circle</mat-icon>
            <div>
                <h2>{{ approvedCount }}</h2>
                <span>Approved</span>
            </div>
        </div>

        <div class="summary-card points">
            <mat-icon>redeem</mat-icon>
            <div>
                <h2>{{ totalPoints }}</h2>
                <span>Total Points</span>
            </div>
        </div>

    </div>

    <!-- Search -->

    <div class="search-section">
        <div class="search-box">
            <mat-icon>search</mat-icon>
            <input type="text" placeholder="Search requests..." (keyup)="applyFilter($event)">
        </div>
    </div>

    <!-- Table -->

    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="redeem-table">

            <!-- User -->

            <ng-container matColumnDef="user">

                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    User
                </th>

                <td mat-cell *matCellDef="let element">

                    <div class="user-cell">

                        <div class="user-avatar">
                            {{ element.user_name }}
                        </div>

                        <!-- <div>

                            <div class="user-name">
                                User #{{ element.user_name }}
                            </div>

                            <div class="user-id">
                                Request #{{ element.id }}
                            </div>

                        </div> -->

                    </div>

                </td>

            </ng-container>

            <!-- Points -->

            <ng-container matColumnDef="points">

                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Points
                </th>

                <td mat-cell *matCellDef="let element">

                    <span class="points-chip">

                        <!-- <mat-icon>
                            redeem
                        </mat-icon> -->

                        {{ element.points }}

                    </span>

                </td>

            </ng-container>

            <!-- Status -->

            <ng-container matColumnDef="status">

                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Status
                </th>

                <td mat-cell *matCellDef="let element">

                    <span class="status-badge" [ngClass]="element.type">

                        {{ element.type | titlecase}}

                    </span>

                </td>

            </ng-container>

            <!-- Date -->

            <ng-container matColumnDef="date">

                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Requested On
                </th>

                <td mat-cell *matCellDef="let element">

                    <div class="date-cell">

                        {{ element.created_date | date:'dd MMM yyyy' }}

                        <small>

                            {{ element.created_date | date:'hh:mm a' }}

                        </small>

                    </div>

                </td>

            </ng-container>

            <!-- Action -->

            <ng-container matColumnDef="action">

                <th mat-header-cell *matHeaderCellDef>
                    Action
                </th>

                <td mat-cell *matCellDef="let element">

                    <div class="action-buttons" *ngIf="element.type === 'pending'">

                        <button mat-flat-button color="primary" (click)="approveRequest(element)">

                            Approve

                        </button>

                        <button mat-stroked-button color="warn" (click)="rejectRequest(element)">

                            Reject

                        </button>

                    </div>

                    <div class="approved-label" *ngIf="element.type === 'debit'">

                        <mat-icon>
                            check_circle
                        </mat-icon>

                        Approved

                    </div>

                    <div class="approved-label" *ngIf="element.type === 'rejected'">

                        <mat-icon>
                            cancel
                        </mat-icon>

                        Rejected

                    </div>

                </td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true">
            </tr>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>

        </table>

    </div>

</div>